var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"7","width":"16","height":"2","fill":"#4285F4","key":0}),React.createElement("rect",{"x":"9","width":"16","height":"2","transform":"rotate(90 9 0)","fill":"#4285F4","key":1})]);
}

Plus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
